import api from '@/api'
import {
  remove
} from 'lodash'
import store from '../index'

const state = {
  user: {},
  userRes: {}, //用户接口完整数据,各个地方用到
  address: {},
  skipDraw: false,
  authStatus: null,
  footmarkList: [],
  messageCount: ''
}
const SET_USER = 'SET_USER'
const SET_USER_RES = 'SET_USER_RES'
const SET_ADDRESS = 'SET_ADDRESS'
const SET_AUTH_STATUS = 'SET_AUTH_STATUS'
const SET_SKIP_DRAW = 'SET_SKIP_DRAW'
const ADD_FOOTMARK_LIST = 'ADD_FOOTMARK_LIST'
const CLEAR_FOOTMARK_LIST = 'CLEAR_FOOTMARK_LIST'
const CLEAR = 'CLEAR'
const SET_MESSAGE_COUNT = 'SET_MESSAGE_COUNT'

const mutations = {
  [SET_AUTH_STATUS](state, val) {
    state.authStatus = val
  },
  [SET_USER](state, val) {
    state.user = val
  },
  [SET_USER_RES](state, val) {
    state.userRes = val
  },
  [SET_ADDRESS](state, val) {
    state.address = val
  },
  [SET_SKIP_DRAW](state, val) {
    state.skipDraw = val
  },
  [SET_MESSAGE_COUNT](state, val) {
    if (val > 0) {
      state.messageCount = val
    } else {
      state.messageCount = ''
    }
  },
  [CLEAR_FOOTMARK_LIST](state) {
    state.footmarkList = []
  },
  [ADD_FOOTMARK_LIST](state, val) {
    if (state.footmarkList.indexOf(val) === -1) {
      state.footmarkList.push(val)
    }
  },
  [CLEAR](state) {
    state.authStatus = false
    state.user = {}
    state.address = {}
    state.skipDraw = false
  }
}

const actions = {
  getUserInfo({
    commit
  }, {
    params = {},
    withoutLogin = false
  } = {}) {
    params = {
      ...{
        with_point: 1,
        with_tijian: 1
      },
      ...params
    }
    return new Promise((resolve) => {
      // 已获取过信息不在获取
      if (store.state.user && store.state.user.user && JSON.stringify(store.state.user.user) !== "{}") {
        let res = {
          code: 200,
          data: store.state.user.user,
          message: "请求成功"
        }
        resolve(res)
        return;
      }

      api.user.info({
        params,
        withoutLogin
      }).then((res) => {
        if (res.code === 200) {
          commit(SET_USER, res.data)
        }
        resolve(res)
      })
    })
  },
  //用最新的用户信息
  getNewUserInfo({
    commit
  }, {
    params = {},
    withoutLogin = false
  } = {}) {
    params = {
      ...{
        with_point: 1,
        with_tijian: 1
      },
      ...params
    }
    return new Promise((resolve) => {
      api.user.info({
        params,
        withoutLogin
      }).then((res) => {

        if (res.code === 200) {
          commit(SET_USER, res.data)
        }
        commit(SET_USER_RES, res)
        resolve(res)
      })
    })
  },

  // 获取基础的用户信息
  getBasicUserInfo({
    commit
  }, {
    params = {},
    withoutLogin = false
  } = {}) {
    return new Promise((resolve) => {
      api.user.info({
        params,
        withoutLogin
      }).then((res) => {

        if (res.code === 200) {
          commit(SET_USER, res.data)
        }
        commit(SET_USER_RES, res)
        resolve(res)
      })
    })
  },

  removeUserCache({
    commit
  }, {
    params = {},
    withoutLogin = false
  } = {}) {
    commit(SET_USER, {})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
